"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmAccountViewContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _ConfirmAccountView = require("./ConfirmAccountView");
var _view = require("../../actions/view");
var _phoneAuth = require("../../actions/phoneAuth");
var _reactRedux = require("react-redux");
function mapStateToProps(state) {
  return {
    status: state.phoneAuth.authenticateByToken.status,
    email: state.phoneAuth.authenticateByToken.account,
    error: state.phoneAuth.authenticateByToken.error,
    source: state.source
  };
}
function mapDispatchToProps(dispatch) {
  return {
    changeView(view, data) {
      dispatch((0, _view.changeView)(view, data));
    },
    authenticateByToken(params) {
      dispatch((0, _phoneAuth.authenticateByToken)(params));
    }
  };
}
const ConfirmAccountViewContainer = exports.ConfirmAccountViewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ConfirmAccountView.ConfirmAccountView);